
import { ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";

interface FeatureCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  path: string;
  className?: string;
}

const FeatureCard = ({ title, description, icon, path, className }: FeatureCardProps) => {
  const navigate = useNavigate();
  
  return (
    <Card 
      className={cn(
        "search-card cursor-pointer border-transparent hover:-translate-y-1 transition-all", 
        className
      )}
      onClick={() => navigate(path)}
    >
      <CardContent className="pt-6">
        <div className="mb-4 text-travel-blue">{icon}</div>
        <h3 className="text-lg font-medium mb-2">{title}</h3>
        <p className="text-gray-600 text-sm">{description}</p>
      </CardContent>
    </Card>
  );
};

export default FeatureCard;
